import { Select, Tag } from "@arco-design/web-react";

import type { ItineraryCopyTarget } from "../types";

type Props = {
  hasSearched: boolean;
  items: ItineraryCopyTarget[];
  selectedDemandId: string;
  loading: boolean;
  onSearch: (value: string) => void;
  onSelect: (demandId: string) => void;
  placeholder?: string;
  disabled?: boolean;
  emptyMessage?: string;
};

/** 远程搜索并选择可复制的定制版本。 */
export function ItineraryCopyTargetSelect({
  hasSearched,
  items,
  selectedDemandId,
  loading,
  onSearch,
  onSelect,
  placeholder = "输入计调号、定制号或定制标题",
  disabled = false,
  emptyMessage,
}: Props) {
  return (
    <Select
      className={`itinerary-copy-target-select${selectedDemandId ? " is-selected" : ""}`}
      showSearch
      allowClear
      filterOption={false}
      dropdownMenuClassName="itinerary-copy-target-popup"
      value={selectedDemandId || undefined}
      aria-label={placeholder === "输入计调号、定制号或定制标题" ? "搜索计调号、定制号或定制标题" : placeholder}
      placeholder={placeholder}
      disabled={disabled}
      loading={loading}
      notFoundContent={(
        <span className="itinerary-copy-target-empty">
          {loading ? "正在搜索..." : emptyMessage ?? (hasSearched ? "暂无匹配的定制版本" : "输入关键词开始搜索")}
        </span>
      )}
      onSearch={(value, reason) => {
        // Arco 在选项收起时会以 optionListHide 原因回调空值，不能把它当作新的远程搜索。
        if (reason === "manual") onSearch(value);
      }}
      onChange={(value) => onSelect(String(value ?? ""))}
    >
      {items.map((item) => (
        <Select.Option key={item.demandId} value={item.demandId}>
          <div className="itinerary-copy-target-option">
            <div className="itinerary-copy-target-option__meta">
              <strong>{item.projectCode}</strong>
              <span>{item.versionNumber}</span>
              <span>{item.salesUserName || "销售未分配"}</span>
              <span>{item.dispatcherUserName || "计调未分配"}</span>
              {item.hasItinerary ? <Tag color="orange">已关联行程</Tag> : null}
            </div>
            <div className="itinerary-copy-target-option__title" title={item.projectTitle}>
              {item.projectTitle}
            </div>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
}
